import { render, staticRenderFns } from "./Lotto.vue?vue&type=template&id=20b20443"
import script from "./Lotto.vue?vue&type=script&lang=js"
export * from "./Lotto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports